import type { ReactNode } from "react";
import { cn } from "./cn";

export type Tone = "neutral" | "accent" | "good" | "warning" | "critical";

const tones: Record<Tone, string> = {
  neutral: "bg-surface-3 text-ink-2",
  accent: "bg-accent-wash text-accent-text",
  good: "bg-good-wash text-good-ink",
  warning: "bg-warning-wash text-ink",
  critical: "bg-critical-wash text-critical-ink",
};

export function Badge({
  tone = "neutral",
  children,
  className,
  icon,
  title,
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
  title?: string;
}) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex h-5 items-center gap-1 rounded-md px-1.5 text-[11px] font-semibold tracking-wide whitespace-nowrap uppercase",
        tones[tone],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
